import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { formatPrice } from "@/lib/api";

const ProductCard = ({ product }) => {
  return (
    <Link
      to={`/product/${product.id}`}
      className="bg-white rounded-sm p-3 flex flex-col fk-card-hover"
      data-testid={`product-card-${product.id}`}
    >
      <div className="relative h-40 sm:h-48 flex items-center justify-center mb-3">
        <img
          src={product.image_url}
          alt={product.name}
          className="max-h-full max-w-full object-contain mix-blend-multiply"
          loading="lazy"
        />
        {product.tagline && (
          <span className="absolute top-0 left-0 bg-[#ff9f00] text-white text-[10px] font-semibold px-1.5 py-0.5 rounded-sm">
            {product.tagline}
          </span>
        )}
      </div>

      <h3 className="text-sm text-[#212121] line-clamp-2 min-h-[40px]">
        {product.name}
      </h3>

      <div className="flex items-center gap-2 mt-1.5">
        <span className="flex items-center gap-0.5 bg-[#388e3c] text-white text-[11px] font-bold px-1.5 py-0.5 rounded-sm">
          {product.rating} <Star className="w-2.5 h-2.5 fill-white" />
        </span>
        <span className="text-[12px] text-[#878787] font-medium">
          ({product.rating_count})
        </span>
      </div>

      <div className="flex items-center gap-2 mt-2 flex-wrap">
        <span className="text-base font-semibold text-[#212121]">
          {formatPrice(product.price)}
        </span>
        <span className="text-[13px] text-[#878787] line-through">
          {formatPrice(product.mrp)}
        </span>
        <span className="text-[13px] font-semibold text-[#388e3c]">
          {product.discount_pct}% off
        </span>
      </div>
    </Link>
  );
};

export default ProductCard;
